import type { User } from '$lib/types';

class SessionState {
  me = $state<User | null>(null);

  readonly isAdmin = $derived(this.me?.role === 'admin');
  readonly isHR = $derived(this.me?.role === 'hr');
  readonly isHROrAdmin = $derived(this.me?.role === 'hr' || this.me?.role === 'admin');
  readonly canViewTeamBoard = $derived(Boolean(this.me?.can_view_team_board));
  readonly canViewField = $derived(Boolean(this.me?.can_view_field));
  readonly isFieldScoped = $derived(this.canViewField && !this.isHROrAdmin);

  setMe(me: User) {
    this.me = me;
  }

  clear() {
    this.me = null;
  }
}

export const session = new SessionState();
